import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

export * from './index.default';

let loadPromise: Promise<void> | null = null;
let optionsSet = false;

export type GoogleMapsLocalization = {
  region: string;
  language: string;
};

export function loadGeolocationLibrary(
  googleMapsApiKey: string,
  { region, language }: GoogleMapsLocalization
): Promise<void> {
  if (loadPromise) {
    return loadPromise;
  }

  if (!optionsSet) {
    setOptions({ key: googleMapsApiKey, region, language });
    optionsSet = true;
  }

  loadPromise = importLibrary('places').then(() => undefined);
  loadPromise.catch(() => {
    // Clear cached promise so the next call can retry
    loadPromise = null;
  });
  return loadPromise;
}
